import axios from 'axios';
import { TOKEN_NAME } from '@constants/token';
import { AUTH_TOKEN_ENDPOINT } from '@constants/api';

class Request {
    constructor () {
        this.blacklist = [AUTH_TOKEN_ENDPOINT];
    }

    addInterceptor () {
        // Only allow one listener to be set for the authentication request intercept
        if (this.hasInterceptor()) {
            return;
        }

        this.requestIntercept = axios.interceptors.request.use(request => {
            if (!this.blacklist.includes(request.url)) {
                const token = window.localStorage.getItem(TOKEN_NAME);

                if (token) {
                    request.headers.Authorization = `Bearer ${token}`;
                }
            }

            return request;
        });
    }

    hasInterceptor () {
        return Boolean(this.requestIntercept);
    }

    clearInterceptor () {
        axios.interceptors.request.eject(this.requestIntercept);

        this.requestIntercept = null;
    }

    resetInterceptor () {
        this.clearInterceptor();
        this.addInterceptor();
    }
}

// Export singleton
export default new Request();
